class CartDrawerTabs extends HTMLElement {
    constructor() {
        super();
        
        this.initTabs = this.initTabs.bind(this);
        this.tabClickHandler = this.tabClickHandler.bind(this);
        this.handleCartEvents = this.handleCartEvents.bind(this);
    }
    
    connectedCallback() {
        this.initTabs();
        
        this.addEventListener('click', this.tabClickHandler);
        
        document.addEventListener('cart-drawer:open', this.handleCartEvents);
        document.addEventListener('cart:refresh', this.handleCartEvents);
        document.addEventListener('cart-drawer:updated', this.handleCartEvents);
        
    }
    
    disconnectedCallback() {
        this.removeEventListener('click', this.tabClickHandler);
        document.removeEventListener('cart-drawer:open', this.handleCartEvents);
        document.removeEventListener('cart:refresh', this.handleCartEvents);
        document.removeEventListener('cart-drawer:updated', this.handleCartEvents);
    
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
        // Prase HTML of cart modal section and get content html for multi deal tab
        const resultHtml =  new DOMParser()
        .parseFromString(html, "text/html");

        const liquidTemplate = resultHtml.querySelector('script[type="liquid/template"]').innerHTML;
        const parser = new DOMParser();
        const virtualDoc = parser.parseFromString(liquidTemplate, 'text/html');

        return virtualDoc.querySelector(selector).innerHTML;
    }
    getSectionsToRender() {
        return [
        {
            id: "cart-modal",
            selector: "#cart-multi-deal",
        },
        {
            id: "cart-modal",
            selector: "#cart-drawer-switch-multideal",
        },
        ];
    }
    renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

        if (!sectionElement) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState[section.id],
            section.selector
        );
        });    
    }
    async initDealModal() {
    try {
        const localePrefix = window.location.pathname.split('/')[1];
        const isLocalized = localePrefix && /^[a-z]{2}-[a-z]{2}$/.test(localePrefix);
        const basePath = isLocalized ? `/${localePrefix}` : '';

        const res = await fetch(`${basePath}/?sections=multi-deal-modal`);
        if (!res.ok) {
        console.warn('Failed fetching multi-deal-modal section', res.status);
        return;
        }
        const json = await res.json();
        const html = json['multi-deal-modal'];
        if (!html) return;

        // parse returned HTML and remove any <script type="liquid/template">
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        doc.querySelectorAll('script[type="liquid/template"]').forEach(s => s.remove());
        doc.querySelectorAll('[neptune-liquid]').forEach(el => el.removeAttribute('neptune-liquid'));

        const newContainer = doc.querySelector('.multi-deal-modal__container') || doc.querySelector('#shopify-section-multi-deal-modal') || doc.body;
        const liveContainer = document.querySelector('.multi-deal-modal__container');

        if (liveContainer && newContainer) {
        liveContainer.innerHTML = newContainer.innerHTML;

        this._initInjectedSwipers(liveContainer);

        const dealTitles = Array.from(doc.querySelectorAll("span.deal-header-title"))
            .map(el => el.textContent.trim());

        const dealLinks = document.querySelectorAll(".shop-deal-header");

        dealLinks.forEach(link => {
            const linkText = link.textContent.trim();
            if (dealTitles.includes(linkText)) {
            link.classList.remove('dealer-can-not-click');  
            }
        });



        } else {
        console.warn('multi-deal container not found on page or in response');
        }
    } catch (err) {
        console.error('initDealModal error', err);
    }
    }

    async _ensureSwiperAssets() {
    if (window.Swiper) return;

    if (!document.querySelector('script[data-swiper-cdn]')) {
        await new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
        s.async = true;
        s.setAttribute('data-swiper-cdn', '1');
        s.onload = () => resolve();
        s.onerror = (e) => reject(e);
        document.head.appendChild(s);
        });
        await new Promise(r => setTimeout(r, 50));
    }
    }

    _safeParseJSON(str) {
    if (!str) return null;
    try { return JSON.parse(str); } catch (e) {
        try {
        let s = str.replace(/\n/g, ' ').replace(/,\s*}/g, '}').replace(/,\s*]/g, ']');
        return JSON.parse(s);
        } catch (e2) {
        console.warn('safeParseJSON failed', e2);
        return null;
        }
    }
    }

    async _initInjectedSwipers(root) {
    try {
        if (!root) root = document;
        await this._ensureSwiperAssets();

        const els = Array.from(root.querySelectorAll('[data-swiper-config]'));
        if (!els.length) return;

        els.forEach(el => {
        try {
            if (el._multiDealSwiper && typeof el._multiDealSwiper.destroy === 'function') {
            try { el._multiDealSwiper.destroy(true, true); } catch(e) {}
            el._multiDealSwiper = null;
            delete el._multiDealSwiper;
            }

            const raw = el.getAttribute('data-swiper-config') || '{}';
            let cfg = this._safeParseJSON(raw);
            if (!cfg) {
            const fixed = raw.replace(/([\r\n]+)/g, ' ').replace(/,\s*}/g, '}').replace(/: true\b/g, ': true').replace(/: false\b/g, ': false');
            cfg = this._safeParseJSON(fixed) || {};
            }

            if (!cfg.navigation) {
            const ancestor = el.closest('.multi-deal-item-container-{{ collection.id }}') || el.parentElement;
            const prevSel = '.swiper-button-prev-unique';
            const nextSel = '.swiper-button-next-unique';
            cfg.navigation = { prevEl: prevSel, nextEl: nextSel };
            } else {
            if (cfg.navigation.prevEl && typeof cfg.navigation.prevEl !== 'string') {
                cfg.navigation.prevEl = cfg.navigation.prevEl.selector || '.swiper-button-prev-unique';
            }
            if (cfg.navigation.nextEl && typeof cfg.navigation.nextEl !== 'string') {
                cfg.navigation.nextEl = cfg.navigation.nextEl.selector || '.swiper-button-next-unique';
            }
            }

            if (cfg.pagination && cfg.pagination.el && typeof cfg.pagination.el !== 'string') {
            cfg.pagination.el = cfg.pagination.el.selector || '.pagination';
            }

            cfg.breakpoints = cfg.breakpoints || {
            1: { slidesPerView: cfg.breakpoints?.['1']?.slidesPerView || 2, spaceBetween: cfg.breakpoints?.['1']?.spaceBetween || 12 },
            1025: { slidesPerView: cfg.breakpoints?.['1025']?.slidesPerView || 4, spaceBetween: cfg.breakpoints?.['1025']?.spaceBetween || 16 }
            };

            console.info('[multi-deal] initializing swiper with config', cfg);

            const instance = new window.Swiper(el, cfg);
            el._multiDealSwiper = instance;
            el.dataset.multiDealSwiperInited = '1';

            const imgs = el.querySelectorAll('img');
            if (imgs.length) {
            let loaded = 0;
            imgs.forEach(img => {
                if (img.complete) loaded++;
                else img.addEventListener('load', () => {
                loaded++;
                if (loaded === imgs.length) try { instance.update(); } catch(e){}
                });
            });
            if (loaded === imgs.length) try { instance.update(); } catch(e){}
            } else {
            try { instance.update(); } catch(e){}
            }
            setTimeout(()=> { try { instance.update(); } catch(e){} }, 300);

        } catch (e) {
            console.error('Error init swiper for element', e);
        }
        });

    } catch (err) {
        console.error('_initInjectedSwipers top error', err);
    }
    }
    async initTabs() {
        const localePrefix = window.location.pathname.split('/')[1];
        const isLocalized = localePrefix.match(/^[a-z]{2}-[a-z]{2}$/);
        const basePath = isLocalized ? `/${localePrefix}` : ''; 
        const sectionsResponse = await fetch(`${basePath}/?sections=cart-modal`);
        const sectionsData = await sectionsResponse.json();
        this.renderContents(sectionsData);

        const tabs = this.querySelectorAll('.drawer__heading');
        if (!tabs.length) return;
        
        const activeTab = this.querySelector('.drawer__heading.active') || tabs[0];
        const targetId = activeTab.getAttribute('data-drawer');
        
        tabs.forEach(tab => tab.classList.remove('active'));
        activeTab.classList.add('active');
        
        if (targetId) {
            const targetContent = document.querySelector(targetId);
            if (targetContent) {
                tabs.forEach(tab => {
                    const contentId = tab.getAttribute('data-drawer');
                    if (contentId) {
                        const content = document.querySelector(contentId);
                        if (content) content.classList.add('hidden');
                    }
                });
                
                targetContent.classList.remove('hidden');
            }
        }

        this.initDealModal();
    }
    
    tabClickHandler(event) {
        const tab = event.target.closest('.drawer__heading');
        if (!tab) return;
        
        event.preventDefault();
        event.stopPropagation();
        
        const targetId = tab.getAttribute('data-drawer');
        if (!targetId) return;
        
        this.querySelectorAll('.drawer__heading').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        
        const targetContent = document.querySelector(targetId);
        if (targetContent) {
            this.querySelectorAll('.drawer__heading').forEach(t => {
                const contentId = t.getAttribute('data-drawer');
                if (contentId) {
                    const content = document.querySelector(contentId);
                    if (content) content.classList.add('hidden');
                }
            });
            
            targetContent.classList.remove('hidden');
        
        }
    }
    
    handleCartEvents() {
        setTimeout(this.initTabs, 300);
    }
}

// Define the custom element
customElements.define('cart-drawer-tabs', CartDrawerTabs);

function disableZoomTemporarily(duration = 400) {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;

  const originalContent = viewport.getAttribute('content');
  viewport.setAttribute(
    'content',
    originalContent.replace(/,?\s*maximum-scale=[^,]+|,?\s*user-scalable=[^,]+/g, '') +
      ', maximum-scale=1.0, user-scalable=no'
  );

  setTimeout(() => {
    viewport.setAttribute('content', originalContent);
  }, duration);
}

document.addEventListener('click', function (e) {
  const link = e.target.closest('.shop-deal-header');
  if (!link) return;

  if (link.closest('[data-modal="multi-deal-modal"]')) {
    return; 
  }

  disableZoomTemporarily();

  e.preventDefault();
  e.stopPropagation();

  if (document.activeElement) document.activeElement.blur();
  link.blur();

  const promoTag = link.dataset.promoTag || 'promo: multi-deal';

  const fakeEvent = new CustomEvent('cart:itemAdded', {
    detail: {
      info: {
        items: [
          {
            properties: {
              tags: [promoTag],
            },
          },
        ],
      },
    },
    bubbles: true,
    cancelable: true,
  });

  document.dispatchEvent(fakeEvent);
});


document.addEventListener('cart:itemAdded', function (e) {
    if (window.ignoreNextCartItemAdded) {
    window.ignoreNextCartItemAdded = false;
    const dealModalHere = document.querySelector('[data-modal="multi-deal-modal"]');
    dealModalHere.classList.remove('active');
    return;
    }
  if (e?.detail?.info?.items && e.detail.info.items.length > 0) {
    const itemAdd = e.detail.info.items[0];

    if (itemAdd?.properties?.tags?.some(tag => tag.toLowerCase().includes("promo:"))) {
      setTimeout(() => {
        const dealModal = document.querySelector('[data-modal="multi-deal-modal"]');
        const dealTitles = (document.querySelectorAll("span.deal-header-title"));
        if (dealTitles && dealTitles.length === 0) {
          return;
        }
        const dealModalClose = document.querySelector('.deal-modal-close-button');

        if (!dealModal || !dealModalClose) return;

        if (!dealModalClose.dataset.origOnclick) {
          const origOnclick = dealModalClose.getAttribute('onclick');
          const origNeptune = dealModalClose.getAttribute('neptune-engage');
          if (origOnclick) dealModalClose.dataset.origOnclick = origOnclick;
          if (origNeptune) dealModalClose.dataset.origNeptune = origNeptune;
        }

        dealModalClose.removeAttribute('onclick');
        dealModalClose.removeAttribute('neptune-engage');

        dealModal.classList.add('active');
        dealModal.classList.add('multi-deal-cart-show');
        document.body.classList.add('has-multi-deal-cart-show');
        const handleOutsideClick = (event) => {
          if (!dealModal.contains(event.target)) {
            dealModal.classList.remove('active', 'multi-deal-cart-show');
            document.body.classList.remove('has-multi-deal-cart-show');
            document.removeEventListener('click', handleOutsideClick);
          }
        };
        setTimeout(() => {
          document.addEventListener('click', handleOutsideClick);
        }, 50);

        const observer = new MutationObserver(() => {
          if (!dealModal.classList.contains('active')) {
            const origOnclick = dealModalClose.dataset.origOnclick;
            const origNeptune = dealModalClose.dataset.origNeptune;
            if (origOnclick) dealModalClose.setAttribute('onclick', origOnclick);
            if (origNeptune) dealModalClose.setAttribute('neptune-engage', origNeptune);

            observer.disconnect();
          }
        });

        observer.observe(dealModal, { attributes: true, attributeFilter: ['class'] });

        const handleClose = (ev) => {
          ev.preventDefault();
          ev.stopImmediatePropagation();

          dealModal.classList.remove('active');
          dealModal.classList.remove('multi-deal-cart-show')
          document.body.classList.remove('has-multi-deal-cart-show');



          dealModalClose.removeEventListener('click', handleClose, true);
        };

        dealModalClose.addEventListener('click', handleClose, true);
      }, 1000);
    }
  }
});

document.addEventListener('click', (e) => {
  const button = e.target.closest('.product-deal-item__button--add');
  if (!button) return;

  const wrapper = button.closest('.product-deal-item__action');
  const variantSelect = wrapper.querySelector('.variant');
  const message = wrapper.querySelector('.variant-message');
  const variantId = variantSelect ? variantSelect.value : '';

  message.style.display = 'none';
  message.innerText = '';

  if (!variantId || variantId === '' || variantId.startsWith('Select')) {
    message.innerText = 'Please select a size';
    message.style.display = 'block';

    setTimeout(() => {
      message.style.display = 'none';
    }, 4000);
    return; 
  }

  const originalText = button.innerText;
  button.innerText = 'Adding...';
  button.disabled = true;
  button.style.opacity = '0.7';

  Neptune.cart.add({ id: variantId, quantity: 1 });

  setTimeout(() => {
    button.innerText = originalText;
    button.disabled = false;
    button.style.opacity = '1';

  }, 4000);

  window.ignoreNextCartItemAdded = true;
  document.body.classList.remove('has-multi-deal-cart-show');
});








        